import { adminRequester } from "App";
import { useEffect, useRef, useState } from "react";
import style from "./OrderDashboard.module.css";
import P from "components/P";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import AdminCustomButton, {
  style as buttonStyle,
} from "components/buttons/AdminCustomButton";
import { toast } from "react-toastify";
import { t } from "i18next";
import ToolTip from "components/tooltip/tooltip";
import FlexGrid from "layouts/flex/FlexGrid";
import NiceModal from "@ebay/nice-modal-react";
import { CSpinner } from "@coreui/react";
import _ from "lodash";
import * as XLSX from "xlsx";

const views = [
  {
    label: "입금대기",
    view: "WaitingForPayment",
    condition: {
      order_status: "pending,completed",
      payment_status: "awaiting",
      fulfillment_status: "not_fulfilled,fulfilled,partially_shipped,shipped",
    },
    button: ({ data, width, research }) => (
      <VerticalFlex width={width}>
        <FlexChild padding={"10px 0px"}>
          <AdminCustomButton
            text="임금액 초기화"
            style={buttonStyle.blue}
            onClick={() =>
              adminRequester.updateCustomer(
                data.customer.id,
                {
                  metadata: _.merge(data.customer.metadata || {}, {
                    amount: 0,
                  }),
                },
                () => research()
              )
            }
          />
        </FlexChild>
        <FlexChild padding={"10px 0px"}>
          <AdminCustomButton
            text="입금확인"
            style={buttonStyle.blue}
            onClick={() => {
              adminRequester
                .updateOrderStatus(data.id, {
                  payment_status: "captured",
                })
                .then(() =>
                  adminRequester
                    .updateCustomer(data.customer.id, {
                      metadata: _.merge(data.customer.metadata || {}, {
                        amount: Math.max(
                          0,
                          (Number(data.customer.metadata?.amount) || 0) -
                            (Number(data.payments?.[0]?.amount) || 0)
                        ),
                      }),
                    })
                    .then(() => research())
                );
            }}
          />
        </FlexChild>
        <FlexChild padding={"10px 0px"}>
          <AdminCustomButton
            text="취소신청"
            style={buttonStyle.blue}
            onClick={() =>
              adminRequester.updateOrderStatus(data.id, {
                status: "canceled",
                payment_status: "awaiting",
                fulfillment_status: "canceled",
                canceled_at: new Date(),
              })
            }
          />
        </FlexChild>
      </VerticalFlex>
    ),
  },
  {
    label: "상품준비중",
    view: "ReadyForProduct",
    condition: {
      order_status: "pending",
      payment_status: "captured",
      fulfillment_status: "not_fulfilled",
    },
    button: ({ data, width, research }) => (
      <VerticalFlex width={width}>
        <FlexChild padding={"10px 0px"}>
          <AdminCustomButton
            text="배송대기 처리"
            style={buttonStyle.blue}
            onClick={() => {
              if (data.fulfillments?.length > 0) {
                adminRequester.updateOrderStatus(
                  data.id,
                  {
                    fulfillment_status: "fulfilled",
                  },
                  () => research()
                );
              } else {
                adminRequester
                  .createFulfillment(data.id, {
                    items:
                      data?.items.map((item) => ({
                        item_id: item.id,
                        quantity: item.quantity,
                      })) || [],
                  })
                  .then(() =>
                    adminRequester
                      .updateOrderStatus(data.id, {
                        fulfillment_status: "fulfilled",
                      })
                      .then(() => research())
                  );
              }
            }}
          />
        </FlexChild>
        <FlexChild padding={"10px 0px"}>
          <AdminCustomButton
            text="환불 신청"
            style={buttonStyle.blue}
            onClick={() =>
              adminRequester
                .updateOrderStatus(data.id, {
                  status: "refund",
                  payment_status: "awaiting",
                  fulfillment_status: "not_fulfilled",
                  payment_id: data?.payments?.[data?.payments?.length - 1]?.id,
                })
                .then(() => research())
            }
          />
        </FlexChild>
      </VerticalFlex>
    ),
  },
  {
    label: "배송대기",
    view: "ReadyForShipment",
    condition: {
      order_status: "pending",
      payment_status: "captured",
      fulfillment_status: "fulfilled",
    },
    button: ({ data, width, research }) => (
      <VerticalFlex width={width}>
        <FlexChild padding={"10px 0px"}>
          <AdminCustomButton
            text="배송중 처리"
            style={buttonStyle.blue}
            onClick={() =>
              adminRequester.updateOrderStatus(
                data.id,
                {
                  status: "pending",
                  fulfillment_status: "partially_shipped",
                },
                () => research()
              )
            }
          />
        </FlexChild>
        <FlexChild padding={"10px 0px"}>
          <AdminCustomButton
            text="준비중 처리"
            style={buttonStyle.blue}
            onClick={() =>
              adminRequester.updateOrderStatus(
                data.id,
                {
                  fulfillment_status: "not_fulfilled",
                },
                () => research()
              )
            }
          />
        </FlexChild>
        <FlexChild padding={"10px 0px"}>
          <AdminCustomButton
            text="환불 신청"
            style={buttonStyle.blue}
            onClick={() =>
              adminRequester
                .updateOrderStatus(data.id, {
                  status: "refund",
                  payment_status: "awaiting",
                  fulfillment_status: "not_fulfilled",
                  payment_id: data?.payments?.[data?.payments?.length - 1]?.id,
                })
                .then(() => research())
            }
          />
        </FlexChild>
      </VerticalFlex>
    ),
  },
  {
    label: "배송중",
    view: "Shipping",
    condition: {
      order_status: "pending",
      payment_status: "captured",
      fulfillment_status: "partially_shipped",
    },
    button: ({ data, width, research }) => (
      <VerticalFlex width={width}>
        <FlexChild padding={"10px 0px"}>
          <AdminCustomButton
            text="배송완료 처리"
            style={buttonStyle.blue}
            onClick={() =>
              adminRequester.updateOrderStatus(
                data.id,
                {
                  status: "completed",
                  fulfillment_status: "shipped",
                  fulfillment_id:
                    data?.fulfillments?.[data?.fulfillments?.length - 1]?.id,
                },
                () => research()
              )
            }
          />
        </FlexChild>
        <FlexChild padding={"10px 0px"}>
          <AdminCustomButton
            text="배송대기 처리"
            style={buttonStyle.blue}
            onClick={() => {
              if (data.fulfillments?.length > 0) {
                adminRequester.updateOrderStatus(
                  data.id,
                  {
                    fulfillment_status: "fulfilled",
                  },
                  () => research()
                );
              } else {
                adminRequester
                  .createFulfillment(data.id, {
                    items:
                      data?.items.map((item) => ({
                        item_id: item.id,
                        quantity: item.quantity,
                      })) || [],
                  })
                  .then(() =>
                    adminRequester
                      .updateOrderStatus(data.id, {
                        fulfillment_status: "fulfilled",
                      })
                      .then(() => research())
                  );
              }
            }}
          />
        </FlexChild>
        <FlexChild padding={"10px 0px"}>
          <AdminCustomButton
            text="준비중 처리"
            style={buttonStyle.blue}
            onClick={() =>
              adminRequester.updateOrderStatus(
                data.id,
                {
                  fulfillment_status: "not_fulfilled",
                },
                () => research()
              )
            }
          />
        </FlexChild>
      </VerticalFlex>
    ),
  },
];
function OrderDashboard(props) {
  const [counts, setCounts] = useState();
  const [view, setView] = useState(views[0]);
  const [mounted, setMounted] = useState(false);
  const [orders, setOrders] = useState([]);
  const [limit, setLimit] = useState(20);
  const [page, setPage] = useState(0);
  const [max, setMax] = useState(0);
  const [reload, setReload] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const forcusRef = useRef();
  useEffect(() => {
    setMounted(true);
    adminRequester.getOrderStatus(
      {
        status: "recent",
      },
      ({ data }) => setCounts(data)
    );
  }, []);
  useEffect(() => {
    if (mounted && view) {
      adminRequester.getOrderStatus(
        {
          status: "table",
          ...view?.condition,
          limit: limit,
          offset: page * limit,
        },
        ({ orders, count }) => {
          setOrders(orders);
          setMax(Math.ceil(count / limit));
          setIsLoading(false);
          forcusRef.current.scrollTop = 0;
        }
      );
    }
  }, [mounted, view, limit, page]);
  useEffect(() => {
    if (reload) {
      adminRequester.getOrderStatus(
        {
          status: "table",
          ...view?.condition,
          limit: limit,
          offset: page * limit,
        },
        ({ orders, count }) => {
          setOrders(orders);
          setMax(Math.ceil(count / limit));
          setIsLoading(false);
        }
      );
      setReload(false);
    }
  }, [reload]);
  const research = () => {
    setIsLoading(true);
    setReload(true);
  };
  const getDate = (date) => {
    date = new Date(date);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(date.getDate()).padStart(2, "0")} ${String(
      date.getHours()
    ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
  };
  const openDetail = ({ row }) => {
    NiceModal.show("orderDetail", {
      data: row,
    });
  };

  const headers = [
    { width: 30, text: "No.", Cell: ({ index }) => index + page * limit + 1 },
    {
      width: 120,
      text: "주문일/결제일",
      Cell: ({ row }) => (
        <VerticalFlex>
          <P>{getDate(row.created_at)}</P>
          <P>
            {row?.payments?.[0]?.created_at
              ? getDate(row.payments[0].created_at)
              : "정보 없음"}
          </P>
        </VerticalFlex>
      ),
    },
    {
      width: 100,
      text: "주문코드",
      code: "id",
      Cell: ({ cell }) => (
        <ToolTip
          style={{ width: "max-content", zIndex: 10, backgroundColor: "white" }}
          title={<P>{cell}</P>}
        >
          <P ellipsis width={100}>
            {cell}
          </P>
        </ToolTip>
      ),
    },
    {
      width: 100,
      text: "주문자",
      code: "customer",
      Cell: ({ cell }) => (
        <VerticalFlex flexStart>
          <ToolTip
            style={{
              width: "max-content",
              zIndex: 10,
              backgroundColor: "white",
            }}
            title={
              <P>{`${cell?.first_name && cell.first_name}${
                cell?.first_name && cell?.last_name ? " " : ""
              }`}</P>
            }
          >
            <P width={100} ellipsis>
              {`${cell?.first_name && cell.first_name}${
                cell?.first_name && cell?.last_name ? " " : ""
              }`}
            </P>
          </ToolTip>

          <ToolTip
            style={{
              width: "max-content",
              zIndex: 10,
              backgroundColor: "white",
            }}
            title={<P>{`(${cell.email})`}</P>}
          >
            <P width={100} ellipsis>{`(${cell.email})`}</P>
          </ToolTip>
        </VerticalFlex>
      ),
    },
    {
      width: 80,
      text: "등급",
      code: "groups",
      Cell: ({ cell }) => cell?.[0]?.name || "사업자회원",
    },
    {
      width: 400,
      text: "상품명",
      justifyContent: "flex-start",
      code: "items",
      Cell: ({ cell }) => (
        <FlexGrid columns={2} width="max-content" gap={10} rows={cell.length}>
          {cell
            .sort((a1, a2) =>
              a1?.variant?.product?.title.localeCompare(
                a2?.variant?.product?.title
              )
            )
            ?.map((item) => (
              <>
                <FlexChild width="max-content" key={`${item.id}_title`}>
                  <P
                    width={350}
                    ellipsis
                  >{`${item?.title} ${item.variant?.title}`}</P>
                </FlexChild>
                <FlexChild width="max-content" key={`${item.id}_quantity`}>
                  <P width={50} ellipsis>{`x ${item.quantity}`}</P>
                </FlexChild>
              </>
            ))}
        </FlexGrid>
      ),
    },
    {
      width: 140,
      text: "배송정보",
      justifyContent: "flex-start",
      code: "shipping_address",
      Cell: ({ cell }) => (
        <ToolTip
          style={{
            zIndex: 10,
            width: "max-content",
            padding: 10,
            backgroundColor: "white",
            border: "1px solid black",
          }}
          title={
            <VerticalFlex backgroundColor="white" flexStart padding={10}>
              <P width="max-content">
                {`${
                  cell?.company && cell?.company !== "default"
                    ? cell.company
                    : ""
                }${
                  cell?.company &&
                  cell?.company !== "default" &&
                  (cell?.first_name || cell?.last_name)
                    ? " "
                    : ""
                }${
                  cell?.first_name || cell?.last_name
                    ? `${cell?.first_name && cell.first_name}${
                        cell.first_name && cell.last_name ? " " : ""
                      }${cell.last_name ? cell.last_name : ""}`
                    : ""
                }`.replace("default ", "")}
              </P>
              <P>
                {`${cell?.postal_code ? `(${cell.postal_code})` : ""}${
                  cell?.postal_code && (cell?.address_1 || cell.address_2)
                    ? " "
                    : ""
                }${cell?.address_1 ? cell.address_1 : ""}${
                  cell.address_1 && cell.address_2 ? " " : ""
                }${cell?.address_2 ? cell.address_2 : ""}`}
              </P>
            </VerticalFlex>
          }
        >
          <VerticalFlex>
            <P ellipsis width={140}>
              {`${
                cell?.company && cell?.company !== "default" ? cell.company : ""
              }${
                cell?.company &&
                cell?.company !== "default" &&
                (cell?.first_name || cell?.last_name)
                  ? " "
                  : ""
              }${
                cell?.first_name || cell?.last_name
                  ? `${cell?.first_name && cell.first_name}${
                      cell.first_name && cell.last_name ? " " : ""
                    }${cell.last_name ? cell.last_name : ""}`
                  : ""
              }`.replace("default ", "")}
            </P>
            <P ellipsis width={140}>
              {`${cell?.postal_code ? `(${cell.postal_code})` : ""}${
                cell?.postal_code && (cell?.address_1 || cell.address_2)
                  ? " "
                  : ""
              }${cell?.address_1 ? cell.address_1 : ""}${
                cell.address_1 && cell.address_2 ? " " : ""
              }${cell?.address_2 ? cell.address_2 : ""}`}
            </P>
          </VerticalFlex>
        </ToolTip>
      ),
    },
    {
      width: 100,
      text: "배송메시지",
      code: "message",
      // Cell: ({ cell }) => (cell ? cell : "없음"),
      Cell: ({ cell }) =>
        cell ? (
          <ToolTip
            style={{
              width: "max-content",
              zIndex: 10,
              backgroundColor: "white",
            }}
            title={<P ellipsis>{cell}</P>}
          >
            <P width={100} ellipsis>
              {cell}
            </P>
          </ToolTip>
        ) : (
          "없음"
        ),
    },
    {
      width: 80,
      text: view.view === "WaitingForPayment" ? "구매금액\n입금액" : "구매금액",

      // code: "payments",
      Cell: ({ row }) => {
        return view.view === "WaitingForPayment" ? (
          <VerticalFlex alignItems="flex-end">
            <P>
              {Number(row?.payments?.[0]?.amount || 0).toLocaleString("ko-kr")}
            </P>
            <P>
              {Number(row?.customer?.metadata?.amount || 0).toLocaleString(
                "ko-kr"
              )}
            </P>
          </VerticalFlex>
        ) : (
          <P>
            {Number(row?.payments?.[0]?.amount || 0).toLocaleString("ko-kr")}
          </P>
        );
      },
    },
    {
      width: 60,
      text: "상태",
      Cell: ({ row }) => {
        switch (row.status) {
          case "pending": {
            switch (row.payment_status) {
              case "awaiting":
                return "입금 대기";
              default: {
                switch (row.fulfillment_status) {
                  case "not_fulfilled":
                    return "상품 준비";

                  case "fulfilled":
                    return "배송 대기";

                  case "partially_shipped":
                    return "배송 중";

                  default:
                    return "기타";
                }
              }
            }
          }
          case "completed":
            return "배송 완료";
          case "canceled": {
            switch (row.payment_status) {
              case "canceled":
                return "취소 완료";
              default:
                return "취소 신청";
            }
          }
          case "exchange": {
            switch (row.fulfillment_status) {
              default:
                return "교환신청";
              case "returned":
                return "반품됨";
              case "partially_returned":
                return "배송완료 및 미반품";
              case "shipped":
                return "배송 및 교환완료";
            }
          }
          case "refund": {
            switch (row.payment_status) {
              case "refunded": {
                switch (row.fulfillment_status) {
                  case "returned":
                    return "환불완료";
                  default:
                    return "환불완료 및 미반품";
                }
              }
              default: {
                switch (row.fulfillment_status) {
                  case "returned":
                    return "물품반납 및 미환불";
                  default:
                    return "환불신청";
                }
              }
            }
          }
          default: {
            return "기타";
          }
        }
      },
    },
    {
      width: 120,
      text: "운송장번호",
      code: "metadata",
      Cell: ({ cell }) => {
        if (cell.shipping === "null") cell.shipping = null;
        return (
          <P
            hover
            cursor
            onClick={() => {
              const trackingNumber = cell?.shipping; // 운송장 번호 가져오기
              if (!trackingNumber) {
                toast.error(t("운송장 번호가 존재하지 않습니다."), {
                  autoClose: 1000,
                  position: toast.POSITION.BOTTOM_CENTER,
                });
                return;
              } else {
                const trackingUrl = `https://trace.cjlogistics.com/next/tracking.html?wblNo=${trackingNumber.replaceAll(
                  "-",
                  ""
                )}`;

                // 팝업창 옵션 설정
                const popupOptions =
                  "width=800,height=800,scrollbars=yes,resizable=yes";

                // 팝업창 열기
                window.open(trackingUrl, "ShippingStatusPopup", popupOptions);
              }
            }}
          >
            {cell?.shipping ? cell.shipping : "데이터 없음"}
          </P>
        );
      },
    },
    {
      width: 150,
      text: "메모",
      code: "metadata",
      Cell: ({ cell }) => (
        <P color={cell?.memo && "red"} width={130}>
          {cell?.memo || "없음"}
        </P>
      ),
    },
  ];

  return (
    <div className={style.container_outer}>
      <P
        width="100%"
        textAlign="left"
        size={18}
        padding="0px 0px 8px 0px"
        weight={700}
      >
        주문 현황
      </P>
      <div
        className={style.container}
        style={{ display: "flex", flexDirection: "column" }}
      >
        <div className={style.label}>
          <HorizontalFlex
            justifyContent="flex-start"
            gap={60}
            height="max-content"
          >
            {views.map((v) => (
              <FlexChild key={v.view} width="max-content" height="max-content">
                <P
                  style={{
                    paddingRight: "5px",
                    textAlign: "left",
                    fontSize: 15,
                    cursor: "pointer",
                    textDecorationLine: view.view !== v.view ? "" : "underline",
                    position: "relative",
                  }}
                  onClick={() => {
                    setIsLoading(true);
                    setPage(0);
                    setView(v);
                  }}
                >
                  <P style={{ position: "absolute", left: "100%", bottom: 10 }}>
                    +{counts?.[v.view] || 0}
                  </P>
                  {v.label}
                </P>
              </FlexChild>
            ))}
            <FlexChild />
            {view.view === "ReadyForShipment" && (
              <FlexChild width="max-content">
                <AdminCustomButton
                  text="송장 일괄 업로드"
                  style={buttonStyle.white_border}
                  type="file"
                  onChange={async (file, data, indexes) => {
                    const uploadFile = file.files[0];
                    switch (uploadFile.type) {
                      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                      case "text/csv": {
                        const header = [
                          { code: "고객주문번호", attr: "id" },
                          { code: "운송장번호", attr: "shipping" },
                        ];
                        const list = await readExcelFile(
                          uploadFile,
                          (Array.isArray(header) ? header : [header]) || []
                        );
                        Promise.all(
                          list?.map(async (data) => {
                            const { order } = await adminRequester.getOrder(
                              data.id
                            );

                            await adminRequester.updateOrderStatus(order.id, {
                              metadata: _.merge(order.metadata, {
                                shipping: data.shipping,
                              }),
                            });
                          })
                        ).then(() => research());
                        toast.success("정보가 성공적으로 업데이트되었습니다.", {
                          autoClose: 1000,
                          position: toast.POSITION.BOTTOM_CENTER,
                        });
                        break;
                      }
                      default: {
                        toast.error(
                          `${uploadFile.type}은 형식에 맞지 않는 데이터입니다.`,
                          {
                            autoClose: 1000,
                            position: toast.POSITION.BOTTOM_CENTER,
                          }
                        );
                        break;
                      }
                    }

                    file.value = "";
                  }}
                />
              </FlexChild>
            )}
            <FlexChild width="max-content">
              <select
                value={limit}
                onChange={(e) => setLimit(Number(e.target.value))}
              >
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={200}>200</option>
              </select>
            </FlexChild>
          </HorizontalFlex>
        </div>
        <FlexChild
          style={{
            position: "relative",
          }}
        >
          {isLoading && (
            <div
              style={{
                position: "sticky",
                background: "white",
                height: 650,
                width: 1820,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 10,
              }}
            >
              <CSpinner />
            </div>
          )}
          <div
            style={{
              overflowY: "scroll",
              height: 650,
              padding: 10,
              width: orders?.length > 0 ? "max-content" : "100%",
            }}
            ref={forcusRef}
          >
            <VerticalFlex>
              {orders?.length > 0 ? (
                <>
                  <FlexChild>
                    <HorizontalFlex justifyContent="flex-start" gap={20}>
                      {headers.map((header, index) => (
                        <FlexChild
                          key={`header_${index}_${header.text}`}
                          width={header?.width}
                        >
                          <P>{header?.text}</P>
                        </FlexChild>
                      ))}
                    </HorizontalFlex>
                  </FlexChild>
                  <FlexChild padding={"10px 0px 10px 0px"}>
                    <div
                      style={{
                        borderBottom: "1px solid #a0a0a0",
                      }}
                    />
                  </FlexChild>
                  {orders?.map((order, oindex) => (
                    <FlexChild key={order.id}>
                      {oindex > 0 && (
                        <FlexChild padding={"10px 0px 10px 0px"}>
                          <div
                            style={{
                              borderBottom: "1px solid #a0a0a0",
                            }}
                          />
                        </FlexChild>
                      )}
                      <HorizontalFlex
                        justifyContent="flex-start"
                        alignItems="flex-start"
                        gap={20}
                      >
                        {headers?.map((header, index) => {
                          let value;
                          if (header?.Cell) {
                            value = header?.Cell({
                              index: oindex,
                              cell: order?.[header.code],
                              row: order,
                            });
                          } else value = order?.[header.code];
                          if (!value && value !== 0) value = "데이터 없음";
                          if (
                            typeof value === "string" ||
                            typeof value === "number"
                          )
                            value = <P>{value}</P>;

                          return (
                            <FlexChild
                              key={`col_${index}_${order?.id}_${header.text}`}
                              width={header.width}
                              justifyContent={header.justifyContent}
                              onClick={() => openDetail({ row: order })}
                            >
                              {value}
                            </FlexChild>
                          );
                        })}

                        {view?.button && (
                          <view.button
                            data={order}
                            width={100}
                            research={research}
                          />
                        )}
                      </HorizontalFlex>
                    </FlexChild>
                  ))}
                </>
              ) : (
                <FlexChild>
                  <P>주문 목록이 없습니다.</P>
                </FlexChild>
              )}

              {setPage && max > 1 && (
                <HorizontalFlex gap={30} width="max-content" margin="20px 0px">
                  <Move
                    name="《"
                    onClick={() =>
                      setPage(
                        Math.max(
                          0,
                          page % 10 >= 1
                            ? page - (page % 10)
                            : page - 10 - (page % 10)
                        )
                      )
                    }
                    disabled={page === 0}
                  />
                  <Move
                    name="〈"
                    onClick={() => setPage(Math.max(0, page - 1))}
                    disabled={page === 0}
                  />
                  <Page page={page} maxPage={max} setPage={setPage} />
                  <Move
                    name="〉"
                    disabled={page === Math.ceil(max - 1)}
                    onClick={() =>
                      setPage(Math.min(Math.ceil(max - 1), page + 1))
                    }
                  />
                  <Move
                    name="》"
                    disabled={page === Math.ceil(max - 1)}
                    onClick={() =>
                      setPage(
                        Math.min(
                          Math.ceil(max - 1),
                          page % 10 < 9
                            ? page + 9 - (page % 10)
                            : page + 10 - (page % 10)
                        )
                      )
                    }
                  />
                </HorizontalFlex>
              )}
            </VerticalFlex>
          </div>
        </FlexChild>
      </div>
    </div>
  );
}

export default OrderDashboard;

const Page = ({ page, maxPage, setPage }) => {
  const start = page - (page % 10);
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
    .map((n) => start + n)
    .filter((n) => n < maxPage)
    .map((n) => (
      <FlexChild>
        <AdminCustomButton
          style={{ wordBreak: "keep-all" }}
          selected={n === page}
          onClick={() => setPage(n)}
          text={n + 1}
        />
      </FlexChild>
    ));
};
const Move = ({ name, onClick, disabled }) => {
  return (
    <FlexChild>
      <AdminCustomButton onClick={onClick} disabled={disabled} text={name} />
    </FlexChild>
  );
};

const readExcelFile = (file, header) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);
      // const processedData = jsonData.map((row) => ({
      //   id: row["작성일자"],
      //   quantity: row["공급자 성명"],
      // }));
      const processedData = jsonData.map((row) => {
        const data = header?.reduce((acc, head) => {
          acc[head?.attr] = row[head?.code];
          return acc;
        }, {});
        return data;
      });

      resolve(processedData);
    };

    reader.onerror = reject;

    reader.readAsBinaryString(file);
  });
};
